import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useSearchParams,
  Navigate,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/tailwind-compiled.css";
import "./styles/main.scss";
import "./styles/settings.scss";
import "./styles/allintroductions.scss";
import "./styles/style-payment.css";
import "./styles/desktop/agent_dashboard.scss";
import "./styles/desktop/bls-mobile-overrides.scss";
import Home from "./pages/v2/Home";
import NoPage from "./pages/NoPage";
import DeletedWantAd from "./pages/v2/DeletedWantAd";
import CreateWantAd from "./pages/v2/CreateWantAd";
import SelectYourPlan from "./pages/v2/SelectYourPlan";
import CompleteYourProfilePremium from "./pages/v2/CompleteYourProfilePremium";
import CompleteYourProfileDefault from "./pages/v2/CompleteYourProfileDefault";
import WantadDetails from "./pages/v2/WantadDetails";
import StrengthenMemberWantAd from "./pages/StrengthenMemberWantAd";
import StrengthenInventory from "./pages/StrengthenInventory";
import "./App.css";
import { LoadingIndicator } from "./components/Common/LoadingIndicator";
import { LoadingProvider } from "./context/LoadingContext";
import { BLSGateWrapper } from "./components/BLSMobileGate/BLSMobileGate";
import MobileViewSwap from "./components/Common/MobileViewSwap";
import { EnterpriseTourProvider } from "./components/EnterpriseTour/EnterpriseTourContext";
import EnterpriseTour from "./components/EnterpriseTour/EnterpriseTour";
import TourRestartButton from "./components/EnterpriseTour/TourRestartButton";
import { pageURLs } from "@/constants";
import {
  getCookie,
  getLocalStorage,
  loggedInUser,
  removeHtmlClassName,
  removeLocalStorage,
  setHtmlClassName,
  setLocalStorage,
} from "./helpers/common";
import ShowWantAd from "./public/ShowWantAd";
import ShowWantAdMobile from "./public/ShowWantAdMobile";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ViewClientDetails from "./pages/ViewClientDetails";
import MemberEditWantAd from "./pages/MemberEditWantAd";
import HomeLoadingSkeleton from "./pages/HomeLoadingSkeleton";
import GitchaPrivacyPolicy from "./pages/GitchaPrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AgentWantAdConfirmation from "./pages/AgentWantAdConfirmation";
import InventoryDetails from "./pages/v2/InventoryDetails";
import MyFavorites from "./pages/MyFavorites";
import FavoriteClients from "./pages/FavoriteClients";
import ViewInventory from "./pages/ViewInventory";
import MyInventoryListing from "./pages/MyInventoryListing";
import Settings from "./pages/Settings";
import MemberEditInventory from "./pages/MemberEditInventory";
import InventoryConfirmation from "./pages/InventoryConfirmation";
import AgentCreateOrEditInventory from "./pages/AgentCreateOrEditInventory";
import AgentCreateOrEditInventoryDraftListing from "./pages/AgentCreateOrEditInventoryDraftListing";
import GitchaMemberWelcome from "./pages/GitchaMemberWelcome";
import AllIntroductions from "./pages/AllIntroductions.js";
import ReceiveIntroduction from "./pages/ReceiveIntroduction";
import PassCodeRequest from "./pages/PassCodeRequest";
import InventoryAllSentIntroductions from "./pages/InventoryAllSentIntroductions";
import WantadDetailsSkeleton from "./pages/WantadDetailsSkeleton";
import Messaging from "./pages/Messaging";
import GitchaInventoryAddOnboard from "./pages/GitchaInventoryAddOnboard";
import "./mobile/styles/mobile-variables.scss";
import "./mobile/styles/mobile-style.scss";
import "./mobile/styles/v2/mobile-style02.scss";
import "./mobile/styles/clients.scss";
import "./styles/ai-chat.scss";
import "./styles/ai-cowork.scss";
import CreateWantAdNextEditor from "./mobile/pages/v2/CreateWantAdNextEditor";
import ResetPassword from "./mobile/pages/ResetPassword.js";
import WantAdFavorites from "./mobile/pages/WantAdFavorites.js";
import StrengthenWantAd from "./mobile/pages/v2/StrengthenWantAd";
import UserRegister from "./mobile/pages/v2/UserRegister.js";
import ProDashboard from "./mobile/pages/ProDashboard";
import BLSDashboard from "./mobile/pages/BLSDashboard";
import AgentClientsListing from "./mobile/pages/AgentClientListing";
import ViewClient from "./mobile/pages/ViewClient.js";
import ViewClientWantAd from "./mobile/pages/ViewClientWantAd.js";
import ViewInventoryClient from "./mobile/pages/ViewInventoryClient.js";
import WantAdListing from "./mobile/pages/v2/WantAdListing";
import ClientNotesListing from "./mobile/pages/ClientNotesListing.js";
import MobileHome from "./mobile/pages/Home.js";
import SettingsMob from "./mobile/pages/Settings.js";
import MemberViewProperty from "./mobile/pages/MemberViewProperty.js";
import ClientFavorites from "./mobile/pages/ClientFavorites";
import AccountSettings from "./mobile/pages/AccountSettings.js";
import ProfileAgentUserPremiumEdit from "./mobile/pages/v2/ProfileAgentUserPremiumEdit";
import SettingsEditName from "./mobile/pages/SettingsEditName.js";
import SettingsEditEmail from "./mobile/pages/SettingsEditEmail.js";
import SettingsCheckEmail from "./mobile/pages/SettingsCheckEmail.js";
import AddPaymentMethod from "./mobile/pages/AddPaymentMode.js";
import PaymentHistory from "./mobile/pages/PaymentHistory.js";
import EmailNotification from "./mobile/pages/EmailNotification.js";
import TutorialProfileSetup from "./mobile/pages/v2/TutorialProfileSetup.js";
import InventoryTutorialSetup from "./mobile/pages/InventoryTutorialSetup.js";
import InventoryAllIntroductions from "./mobile/pages/v2/InventoryIntroductions.js";

import {
  AgentMyInventory,
  AgentMyWantAdListing,
  CreateInventory,
  AgentMyClients,
  AgentWantAdEditor,
  AgentWantAdDraftEditor,
} from "@/pages";

import {
  ACESS_CODE,
  AGENT_INTRODUCTION,
  AGENT_INVENTORY_CREATE_KEY,
  AGENT_INVENTORY_EDIT_KEY,
  AGENT_WANTAD_KEY,
  INVENTORY_KEY,
  MEMBER_INTRODUCTION,
  MEMBER_INVENTORY_EDIT_KEY,
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  WANT_AD_KEY_EDIT,
} from "./constants/common";
import {
  EMAIL_VERIFICATION,
  RESET_PWD_ACTION,
} from "./constants/onBoarding.js";
import { convertToNumber } from "./helpers/validations.js";
import Inapp from "./mobile/pages/Inapp.js";
import ReceiveIntroductionNotification from "./mobile/pages/ReceiveIntroductionNotification.js";
import ManageInventory from "./mobile/pages/ManageInventory.js";
import HandleViewWantAd from "./mobile/pages/HandleViewWantAd.js";
import AddPropertyInInventory from "./mobile/pages/AddPropertyInInventory.js";
import StrengthenInventoryResponsive from "./mobile/pages/StrengthenInventory.js";
import HandleMessagesScreens from "./mobile/pages/HandleMessagesScreens.js";
import ImagesFullGallery from "./mobile/commonComponents/ImagesFullGallery.js";
import {
  initializeChatMessageCountValue,
  setChatMessageCount,
  setChatMessages,
  setInappNotificationCount,
  setReceiveIntroCount,
} from "./reducers/unReadStatus.js";
import { db } from "./firebase";
import { collection, onSnapshot, query, where, or } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { loginOrSignUp } from "./helpers/message.js";
import {
  getInAppNotications,
  getIntroductions,
} from "./services/introductionService.js";
import { setsseData } from "./reducers/sseData.js";
import BuyerListingCreateWantAdForm from "@/form/BuyerListingCreateWantAdWeb.js";
import CreateAdFormEditor from "./mobile/pages/v2/CreateAdFormEditor";
import BuyerListingCreateWantAdFormMob from "./form/v2/BuyerListingCreateWantAdMob.js";
import FormSubmissionSuccess from "./form/v2/FormSumbissionSuccess.js";
import FormSubmissionSuccessMob from "./form/v2/FormSubmissionSuccessMob.js";
import InvestorDashboard from "./pages/InvestorDashboard.js";
import ShareIntroductionWeb from "./form/ShareIntroductionWeb.js";
import ShareIntroductionMob from "./form/ShareIntroductionMob.js";
import ErrorBoundary from "./components/Common/v2/ErrorBoundary/ErrorBoundary";
import PersistentDashboardShell from "./components/PersistentDashboardShell";
import UserTypeSelection from "./pages/v2/UserTypeSelection";
import AgentInfo from "./pages/AgentInfo";
import DirectMessages from "./pages/v2/DirectMessaging";
import HandleDirectMessagesScreens from "./mobile/pages/v2/HandleDirectMessagesScreens";
import AgentDashboard from "./pages/AgentDashboard";
import ConsumerCreateInventory from "./pages/ConsumerCreateInventory";
import SsoCallback from "./pages/SsoCallback";
import SsoError from "./pages/SsoError";
import ActiveBuyerReport from "./pages/ActiveBuyerReport/ActiveBuyerReport";

function removeLocalStorageData() {
  const wantAdORInventoryPages = [
    pageURLs.agentEditwantad,
    pageURLs.agentCreatewantad,
    pageURLs.wantAdDetails,
    "/agent-want-ad-confirmation",
    "/member-edit-Inventory",
    "/create-inventory",
    "/inventory-confirmation",
  ];
  if (!wantAdORInventoryPages.includes(window.location.pathname)) {
    removeLocalStorage(WANT_AD_KEY_EDIT);
    removeLocalStorage(AGENT_WANTAD_KEY);
    removeLocalStorage(MEMBER_INVENTORY_EDIT_KEY);
    removeLocalStorage(AGENT_INVENTORY_CREATE_KEY);
    removeLocalStorage(AGENT_INVENTORY_EDIT_KEY);
    removeLocalStorage("PhotosAfterDelete");
  }

  // to clear introduction session data on entering home page
  //
  if (
    window.location.pathname == pageURLs.home ||
    window.location.pathname == pageURLs.mobileHome
  ) {
    removeLocalStorage(AGENT_INTRODUCTION);
    removeLocalStorage(MEMBER_INTRODUCTION);
  }
}

const urlRouting = [
  {
    webUrl: pageURLs.agentCreatewantad,
    mobUrl: pageURLs.createWantAdResponsive,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.wantAdPubicDetailsPage,
    mobUrl: pageURLs.wantAdPubicMobileDetailsPage,
    isCheckValidUser: false,
  },
  {
    webUrl: pageURLs.agentDashboard,
    mobUrl: pageURLs.proDashboard,
    isCheckValidUser: true,
  },

  {
    webUrl: pageURLs.createwantad,
    mobUrl: pageURLs.createWantAdResponsive,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.agentMyWantAdListings,
    mobUrl: pageURLs.myWantAds,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.inventoryStrengthen,
    mobUrl: pageURLs.strengthenInventoryReponsive,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.home,
    mobUrl: pageURLs.mobileHome,
  },
  {
    webUrl: pageURLs.mobileBaseRoot,
    mobUrl: pageURLs.mobileHome,
  },
  {
    webUrl: pageURLs.mobileRoot,
    mobUrl: pageURLs.mobileHome,
  },
  {
    webUrl: pageURLs.match,
    mobUrl: pageURLs.mobileMatch,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.wantAdDetails,
    mobUrl: pageURLs.viewAd,
    isCheckValidUser: false,
  },
  {
    webUrl: pageURLs.settings,
    mobUrl: pageURLs.mobileSettings,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.messages,
    mobUrl: pageURLs.mobileMessages,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.directMessages,
    mobUrl: pageURLs.mobileDirectMessages,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.editWantAdForAgents,
    mobUrl: pageURLs.mobileEditWantAd,
    isCheckValidUser: true,
  },
  {
    webUrl: pageURLs.addNewCard,
    mobUrl: pageURLs.mobileAddPaymentMethod,
    isCheckValidUser: true,
  },
];

// const store = setupStore();
function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const user = loggedInUser();
  const _userType = user?.userInfo?.userType;
  const location = useLocation();
  const passCodeStatus = process.env.REACT_APP_PASSCODE_STATUS;
  const pathName = _.get(location, "pathname", null)?.toLowerCase();
  const basicUrl = pathName.split("/")[1];

  const checkUser = (userInfo, targetUrl = null) => {
    const userType = _.get(userInfo, "userType", null);

    const agentTitle = _.get(userInfo, "agentTitle", null);
    const isVerified = _.get(userInfo, "userIsVerified", null);
    const planStatus = _.get(userInfo, "planStatus", null);
    const userStatus = _.get(userInfo, "userStatus", null);
    let isValidUser = true;
    if (userInfo) {
      if (userType) {
        if (isVerified && planStatus && userStatus) {
          isValidUser = true;
        } else {
          if (convertToNumber(userType) === USER_TYPE_AGENT) {
            if (!agentTitle) {
              isValidUser = false;
            } else if (!planStatus) {
              isValidUser = false;
            } else if (!userStatus) {
              isValidUser = false;
            }
          } else {
            if (!planStatus) {
              isValidUser = false;
            } else if (!userStatus) {
              isValidUser = false;
            }
          }
        }
      } else {
        isValidUser = false;
      }
    } else {
      isValidUser = false;
    }
    if (isValidUser) {
      targetUrl && navigate(targetUrl);
    } else {
      if (
        pathName &&
        pathName != pageURLs.mobileHome &&
        !pathName.startsWith(pageURLs.viewAd) &&
        !pathName.startsWith(pageURLs.wantAdDetails) &&
        pathName !== "/privacy-policy" &&
        pathName !== "/terms-of-service" &&
        basicUrl !== "form" &&
        pathName !== pageURLs?.buyerListingConfirmation &&
        !pathName.startsWith("/agent-info")
      ) {
        navigate(pageURLs.mobileSignIn);
      }
    }
  };

  //Logic to update website colors
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];

  const themeMap = {
    default: {
      "--primary-050": "#f4fcff",
      "--primary-100": "#F0F8FF",
      "--primary-150": "#d6eaff",
      "--primary-180": "#97a8cc",
      "--primary-200": "#1990FF",
      "--primary-230": "#1272f6",
      "--primary-250": "#205eca",
      "--primary-290": "#1c52b0",
      "--primary-300": "#0455AC",
      "--primary-400": "#0F3A7B",
      "--primary-500": "#022964",
      "--primary-600": "#002b6b",
      "--primary-850": "#061d50",
      "--primary-900": "#001729",
      "--primary-950": "#000022",

      "--secondary-100": "#E1F5FC",
      "--secondary-150": "#b3e5f7",
      "--secondary-200": "#52c3ec",
      "--secondary-300": "#00B3F2",
      "--secondary-500": "#0089C6",
      "--secondary-600": "#0078B4",
    },
    lar: {
      "--primary-050": "#fff5f5",
      "--primary-100": "#fef0f0",
      "--primary-150": "#fad5d7",
      "--primary-180": "#c99a9c",
      "--primary-200": "#EF3B57",
      "--primary-230": "#DC2A44",
      "--primary-250": "#C41E3A",
      "--primary-290": "#A51A32",
      "--primary-300": "#8B1A1A",
      "--primary-400": "#7A1616",
      "--primary-500": "#8B1A1A",
      "--primary-600": "#6B1414",
      "--primary-850": "#4A0E0E",
      "--primary-900": "#3D0B0B",
      "--primary-950": "#2A0707",

      "--secondary-100": "#FFF0F2",
      "--secondary-150": "#FFD4D9",
      "--secondary-200": "#FF8894",
      "--secondary-300": "#FF5365",
      "--secondary-500": "#D93A52",
      "--secondary-600": "#BA2C42",
    },
  };

  const theme = themeMap[subdomain] || themeMap.default;

  Object.entries(theme).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });

  useEffect(() => {
    const userInfo = _.get(user, "userInfo", null);
    const wantAdId = searchParams.get("wantAdId");
    const InvId = searchParams.get("InvId");
    const ClientId = searchParams.get("ClientId");
    const AdType = searchParams.get("AdType");
    const IsFromMarketing = searchParams.get("IsFromMarketing");
    const Tab = searchParams.get("Tab");
    const id = searchParams.get("id");
    const match = location.pathname.match(/\/want-listing-details\/([^/]+)/);
    const wantAdIdFromURL = match ? match[1] : null;
    removeLocalStorageData(); // to remove local storage data
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      if (pathName) {
        // add a class name for messages screen html tag and remove the class name in other pages
        if (pathName == pageURLs.mobileMessages) {
          setHtmlClassName("h-m-100");
        } else {
          removeHtmlClassName("h-m-100");
        }
        const action = searchParams.get("action");

        //For handling email link clicking

        if (action) {
          const userId = searchParams.get("Id");
          const gCode = searchParams.get("g_code");
          if (convertToNumber(action) === RESET_PWD_ACTION) {
            navigate(
              pageURLs.changePassword +
              `?action=${RESET_PWD_ACTION}&Id=${userId}&g_code=${gCode}`,
            );
          } else if (convertToNumber(action) === EMAIL_VERIFICATION) {
            navigate(
              pageURLs.mobileSignIn +
              `?action=${EMAIL_VERIFICATION}&Id=${userId}&g_code=${gCode}`,
            );
          }
        } // end of email link clicking condition

        //  Redirection to mobile pages if a web url is coming
        else {
          const filteredArray = urlRouting.filter(function (ca) {
            return ca.webUrl === pathName;
          });
          if (wantAdIdFromURL && pathName.startsWith(pageURLs.wantAdDetails)) {
            navigate(`${pageURLs.viewAd}/${wantAdIdFromURL}`);
          }
          if (filteredArray.length > 0) {
            const mobUrl = _.get(filteredArray[0], "mobUrl", null);
            if (wantAdId && pathName === pageURLs.wantAdPubicDetailsPage) {
              navigate(mobUrl + `?wantAdId=${wantAdId}`);
            } else if (id && pathName === pageURLs.directMessages) {
              checkUser(userInfo, mobUrl + `?id=${id}`);
            } else if (wantAdId && pathName === pageURLs.wantAdDetails) {
              checkUser(userInfo, mobUrl + `?wantAdId=${wantAdId}`);
            } else if (wantAdId && pathName === pageURLs.editWantAdForAgents) {
              checkUser(userInfo, mobUrl + `?wantAdId=${wantAdId}`);
            } else if (Tab && pathName === pageURLs.agentMyWantAdListings) {
              // my want ad listing page redirection to mobile view
              checkUser(userInfo, mobUrl + `?Tab=${Tab}`);
            } else if (
              AdType &&
              InvId &&
              ClientId &&
              pathName === pageURLs.match
            ) {
              checkUser(
                userInfo,
                mobUrl +
                `?InvId=${InvId}&ClientId=${ClientId}&AdType=${AdType}`,
              );
            } else {
              const isCheckValidUser = _.get(
                filteredArray[0],
                "isCheckValidUser",
                null,
              );
              if (mobUrl) {
                if (isCheckValidUser) {
                  checkUser(userInfo, mobUrl);
                } else {
                  if (!IsFromMarketing) {
                    navigate(mobUrl);
                  }
                }
              }
            }
          } else {
            if (
              pathName !== pageURLs.changePassword &&
              pathName !== pageURLs.wantAdPubicMobileDetailsPage &&
              basicUrl !== "form" &&
              pathName !== pageURLs?.buyerListingConfirmation
            ) {
              checkUser(userInfo);
            }
          }
        }
      }
    } else {
      // Public want ad link routing to web url if mobile url is coming
      if (wantAdId && pathName === pageURLs.wantAdPubicMobileDetailsPage) {
        navigate(pageURLs.wantAdPubicDetailsPage + `?wantAdId=${wantAdId}`);
      } else if (wantAdId && pathName === pageURLs.viewAd) {
        checkUser(userInfo, pageURLs.wantAdDetails + `?wantAdId=${wantAdId}`);
      } else if (
        AdType &&
        InvId &&
        ClientId &&
        pathName === pageURLs.mobileMatch
      ) {
        checkUser(
          userInfo,
          pageURLs.match +
          `?InvId=${InvId}&ClientId=${ClientId}&AdType=${AdType}`,
        );
      } else {
        if (!userInfo) {
          if (passCodeStatus == 2) {
            const accessToken = getCookie(ACESS_CODE); // to check page redirection if access code enterd or not
            if (
              pathName &&
              pathName !== "/privacy-policy" &&
              pathName !== "/terms-of-service" &&
              basicUrl !== "form" &&
              pathName !== pageURLs?.buyerListingConfirmation
            ) {
              if (!wantAdId) {
                if (accessToken) {
                  navigate(pageURLs.home);
                } else {
                  navigate(pageURLs.accessCodePage);
                }
              }
            }
          }
        }
      }
    }
  }, [pathName]);
  //this is for testing
  function RequireAuth({ children, roles }) {
    const user = loggedInUser();
    const userInfo = _.get(user, "userInfo", null);
    const usertype = parseInt(_.get(userInfo, "userType", null));
    const planStatus = _.get(userInfo, "planStatus", null);
    const userStatus = _.get(userInfo, "userStatus", null);
    let location = useLocation();

    const userHasRequiredRole = user && roles.includes(usertype) ? true : false;

    if (!user) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    if (!userHasRequiredRole) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    if (!planStatus || !userStatus) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
  }

  // to check web home page to load mobile / web view
  function CheckMobileView({ children }) {
    const user = loggedInUser();
    const userInfo = _.get(user, "userInfo", null);
    const pathName = _.get(location, "pathname", null)?.toLowerCase();
    const userType = _.get(userInfo, "userType", null);
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      //For handling users from marketing page
      const IsFromMarketing = searchParams.get("IsFromMarketing");
      const action = searchParams.get("action");
      if (IsFromMarketing && pathName == "/home") {
        const userAction = searchParams.get("userAction");
        const utm_source = searchParams.get("utm_source");
        const utm_medium = searchParams.get("utm_medium");
        const utm_campaign = searchParams.get("utm_campaign");

        if (utm_source || utm_medium || utm_campaign) {
          setLocalStorage("utmData", {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
          });
        }

        const userActionLogin = "LOGIN";
        const userActionSignUp = "SIGNUP";
        const userActionCreateWantAd = "POSTWANTAD";
        const location = searchParams.get("location");
        if (location) {
          setLocalStorage("LocationString", location);
        }

        if (!userType) {
          return (
            <Navigate
              to={pageURLs.mobileSignIn}
              state={{ IsFromMarketing: IsFromMarketing, action: userAction }}
              replace
            />
          );
        } else {
          if (userAction === userActionCreateWantAd) {
            return <Navigate to={pageURLs.createWantAdResponsive} replace />;
          } else if (
            userAction == userActionLogin ||
            userAction == userActionSignUp
          ) {
            return <Navigate to={pageURLs.mobileHome} replace />;
          } else {
            return <Navigate to={pageURLs.mobileHome} replace />;
          }
        }
      } else {
        if (!userType) {
          return <Navigate to={pageURLs.mobileSignIn} replace />;
        } else {
          return <Navigate to={pageURLs.mobileHome} replace />;
        }
      }
    } else {
      return children;
    }
  }

  const UserId =
    _.get(user, "userInfo.userId", null) ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);

  // SSE integration
  useEffect(() => {
    let mount = true;
    let events;
    let timer;
    let createEvents = () => {
      // Close connection if open
      if (events) {
        events.close();
      }
      // Establishing an SSE connection
      events = new EventSource(
        process.env.REACT_APP_API_BASE_URL + "connect?userId=" + UserId,
      );
      events.onmessage = (event) => {
        if (mount) {
          const parsedData = JSON.parse(event.data);
          const formatedParsedData = JSON.parse(parsedData);
          const clientId = formatedParsedData?.subjectId;
          dispatch(setsseData(null));
          if (formatedParsedData?.messageType == "in-app") {
            dispatch(setsseData(formatedParsedData));

            getNotificationList(); // to set the unread in app message count
            if (formatedParsedData?.subjectType === 12) {
              const pathName = _.get(location, "pathname", null);
              if (pathName && pathName === pageURLs.inventoryDetails) {
                const inventoryId = _.get(
                  getLocalStorage(INVENTORY_KEY),
                  "inventoryId",
                  null,
                );
                if (inventoryId) {
                  dispatch(setsseData(formatedParsedData));
                }
              }
              if (
                pathName &&
                pathName === pageURLs.mobilememberInventoryDetails
              ) {
                const inventoryId = _.get(
                  getLocalStorage(INVENTORY_KEY),
                  "inventoryId",
                  null,
                );
                if (inventoryId) {
                  dispatch(setsseData(formatedParsedData));
                }
              }
            }
          } else if (formatedParsedData?.messageType == "receiveIntroduction") {
            dispatch(setsseData(formatedParsedData));
            const wantAdId = null;
            let page = 1;
            getIntroductionList(page, wantAdId);
          } else if (formatedParsedData?.messageType == "exportNotes") {
            window.open(
              process.env.REACT_APP_S3_BASE_URL +
              "/ClientNotes/" +
              clientId +
              ".pdf",
              "_blank",
            );
          }
        }
      };
      events.onerror = (err) => {
        console.log("err", err);
        // timer = setTimeout(() => {
        //   createEvents();
        // }, 1000);
      };
    };

    createEvents();
    return () => {
      mount = false;
      clearTimeout(timer);
      events.close();
    };
  }, [UserId]);

  /**
   * To set the unread inapp notidication count
   */
  const getNotificationList = async () => {
    const reqPayload = {};
    await getInAppNotications(reqPayload).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          dispatch(
            setInappNotificationCount(
              _.get(response, "result.unReadMessageCount", 0),
            ),
          );
        }
      }
    });
  };

  // receive Intro list
  const getIntroductionList = async (page, wantAdId) => {
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    const reqPayload = {
      userId: userId,
      wantAdId: wantAdId,
      page: page,
      limit: 1,
      isAccept: "1",
    };
    await getIntroductions(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        if (response.errorCode === 0) {
          dispatch(
            setReceiveIntroCount(
              _.get(response, "result.unReadMessageCount", 0),
            ),
          );
        }
      }
    });
  };

  // api call for chat messages

  useEffect(() => {
    const userDetails = loggedInUser();
    let email = _.get(userDetails, "userInfo.email", null);
    if (email) {
      let login = loginOrSignUp(email);
      if (!login) {
        // navigate(pageURLs.home);
      } else {
        // api call for get receive intro count
        const wantAdId = null;
        let page = 1;
        getIntroductionList(page, wantAdId);
        getNotificationList();
      }
    }
  }, []);

  useEffect(() => {
    const q = query(
      collection(db, "Introduction"),
      or(
        where("inventroyCreatedId", "==", UserId),
        where("wantAdCreatedId", "==", UserId),
      ),
    );

    const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
      let fetchedMessages = [];
      let orderd = [];
      QuerySnapshot.forEach((doc) => {
        fetchedMessages.push({ ...doc.data(), id: doc.id });
      });

      dispatch(setChatMessages(fetchedMessages));

      orderd = fetchedMessages?.filter(
        (item) => item.isaccepted == true && item.isdeleted == false,
      );

      if (orderd && orderd.length > 0) {
        dispatch(initializeChatMessageCountValue());
        orderd.forEach((msg) => {
          if (msg?.wantAdCreatedId == UserId) {
            if (msg?.isWantAdOwnerHasUnreadMessage == true) {
              dispatch(setChatMessageCount());
            }
          } else {
            if (msg?.isInventoryOwnerHasUnreadMessage == true) {
              dispatch(setChatMessageCount());
            }
          }
        });
      }
    });

    return () => unsubscribe;
  }, [UserId]);

  const checkIsMobileView = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      return true;
    } else false;
  };


  return (
    <LoadingProvider>
      <BLSGateWrapper>
      <LoadingIndicator />
      <ToastContainer position="bottom-center" className="toast-message" />
      {window.location.origin.includes(
        process.env.REACT_APP_BUYERLISTING_SERVICE_BASE_URL,
      ) && window.__TENANT__?.featureFlags?.forms !== false ? (
        <Routes>
          {/* BuyerListing Form */}

          <Route
            path="/form/:id"
            element={
              <ErrorBoundary>
                {checkIsMobileView() ? (
                  <BuyerListingCreateWantAdFormMob />
                ) : (
                  <BuyerListingCreateWantAdForm />
                )}
              </ErrorBoundary>
            }
            exact
          />

          <Route
            path="/confirmation"
            element={
              <ErrorBoundary>
                {checkIsMobileView() ? (
                  <FormSubmissionSuccessMob />
                ) : (
                  <FormSubmissionSuccess />
                )}
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path="/form/introduction/:id"
            element={
              checkIsMobileView() ? (
                <ShareIntroductionMob />
              ) : (
                <ShareIntroductionWeb />
              )
            }
            exact
          />
        </Routes>
      ) : (
        <EnterpriseTourProvider>
        <PersistentDashboardShell>
        <EnterpriseTour />
        <TourRestartButton />
        <Routes>
          {/* passcode barrier route */}
          <Route
            path="/"
            element={passCodeStatus == 2 ? <PassCodeRequest /> : <Home />}
            exact
          />
          <Route
            path="/home"
            element={
              <CheckMobileView>
                <Home />
              </CheckMobileView>
            }
            exact
          />
          <Route path="/match" element={<Home />} exact />

          <Route path={pageURLs.selectYourPlan} element={<SelectYourPlan />} />
          <Route
            path={pageURLs.completeYourProfilePremium}
            element={<CompleteYourProfilePremium />}
          />
          <Route
            path={pageURLs.completeYourProfileDefault}
            element={<CompleteYourProfileDefault />}
          />

          <Route
            path={pageURLs.createwantad}
            element={
              <RequireAuth roles={[1]}>
                <CreateWantAd />
              </RequireAuth>
            }
            exact
          />
          {/* SAML SSO callback and error routes */}
          <Route path="/sso-callback" element={<SsoCallback />} />
          <Route path="/sso-error" element={<SsoError />} />
          <Route path="*" element={<NoPage />} />
          <Route
            path={`${pageURLs.wantAdDetails}/:wantAdId`}
            element={
              <ErrorBoundary>
                <WantadDetails />
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path="/strengthen-want-ad"
            element={
              <ErrorBoundary>
                <RequireAuth roles={[1, 2]}>
                  <StrengthenMemberWantAd />
                </RequireAuth>
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path={pageURLs.agentMyWantAdListings}
            element={
              <RequireAuth roles={[2]}>
                <AgentMyWantAdListing />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentInventoryListing}
            element={
              <RequireAuth roles={[2]}>
                <AgentMyInventory />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentMyClients}
            element={
              <RequireAuth roles={[2]}>
                <AgentMyClients />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/agent-dashboard"
            element={
              <RequireAuth roles={[2]}>
                <MobileViewSwap
                  desktop={<AgentDashboard />}
                  mobile={<BLSDashboard />}
                />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/investor-dashboard"
            element={
              <RequireAuth roles={[1]}>
                <InvestorDashboard />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-client"
            element={
              <RequireAuth roles={[2]}>
                <ViewClientDetails />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/loading-skeleton"
            element={<HomeLoadingSkeleton />}
            exact
          />
          <Route
            path={pageURLs.agentEditwantad}
            element={
              <RequireAuth roles={[1]}>
                <MemberEditWantAd />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/privacy-policy"
            element={<GitchaPrivacyPolicy />}
            exact
          />
          <Route path="/terms-of-service" element={<TermsOfService />} exact />
          <Route
            path={pageURLs.wantAdPubicDetailsPage}
            element={<ShowWantAd />}
            exact
          />
          <Route
            path={pageURLs.wantAdPubicMobileDetailsPage}
            element={<ShowWantAdMobile />}
            exact
          />
          <Route path="/404-not-found" element={<NoPage />} exact />
          <Route
            path={pageURLs.deletedWantAd}
            element={<DeletedWantAd />}
            exact
          />
          <Route
            path={pageURLs.agentCreatewantadMainScreen}
            element={<AgentWantAdDraftEditor />}
            exact
          />
          <Route
            path={pageURLs.agentCreatewantad}
            element={
              <RequireAuth roles={[2]}>
                <AgentWantAdEditor />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.editWantAdForAgents}
            element={
              <RequireAuth roles={[2]}>
                <AgentWantAdEditor />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentWantAdConfirmation}
            element={
              <RequireAuth roles={[2]}>
                <AgentWantAdConfirmation />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/wantad-details-skeleton"
            element={<WantadDetailsSkeleton />}
            exact
          />
          <Route
            path="/create-inventory"
            element={
              <RequireAuth roles={[1, 2]}>
                {_userType === 2 ? (
                  <AgentCreateOrEditInventory />
                ) : (
                  <ConsumerCreateInventory />
                )}
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/strengthen-inventory"
            element={
              <RequireAuth roles={[1, 2]}>
                <StrengthenInventory />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/inventory-details"
            element={
              <RequireAuth roles={[1, 2]}>
                <InventoryDetails />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/my-favorites"
            element={
              <RequireAuth roles={[1, 2]}>
                <MyFavorites />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/favorite-clients"
            element={
              <RequireAuth roles={[2]}>
                <FavoriteClients />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-inventory"
            element={
              <ErrorBoundary>
                <ViewInventory />
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path={pageURLs.consumerInventoryListing}
            element={
              <RequireAuth roles={[1, 2]}>
                <MyInventoryListing />
              </RequireAuth>
            }
            exact
          />
          {/* Inventory */}
          <Route
            path="/member-edit-Inventory"
            element={
              <RequireAuth roles={[1]}>
                <MemberEditInventory />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/inventory-confirmation"
            element={
              <RequireAuth roles={[1, 2]}>
                <InventoryConfirmation />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/agent-draft-inventory"
            element={<AgentCreateOrEditInventoryDraftListing />}
            exact
          />
          <Route path="/enter-passcode" element={<PassCodeRequest />} exact />
          <Route
            path={pageURLs.gitchaMemberWelcome}
            element={
              <RequireAuth roles={[1, 2]}>
                <GitchaMemberWelcome />
              </RequireAuth>
            }
            exact
          />

          {/* <Route
            path={pageURLs.shareWantAdDetails}
            element={<ShareWantAdDetailsPage />}
          /> */}
          <Route
            path="/settings"
            element={
              <RequireAuth roles={[1, 2]}>
                <Settings />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/add-new-card"
            element={
              <RequireAuth roles={[1, 2]}>
                <Settings addNewCard={true} />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/edit-agent-profile"
            element={
              <RequireAuth roles={[1, 2]}>
                <Settings editAgentProfile={true} />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/all-introductions"
            element={
              <RequireAuth roles={[1, 2]}>
                <AllIntroductions />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-introduced-property"
            element={
              <RequireAuth roles={[1, 2]}>
                <ReceiveIntroduction />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-all-introductions"
            element={
              <RequireAuth roles={[1, 2]}>
                <InventoryAllSentIntroductions />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/messages"
            element={
              <RequireAuth roles={[1, 2]}>
                <Messaging />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/direct-messages"
            element={
              <RequireAuth roles={[1, 2]}>
                <DirectMessages />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/inventory-onboard"
            element={<GitchaInventoryAddOnboard />}
            exact
          />
          <Route
            path={pageURLs.createWantAdResponsive}
            element={<CreateWantAdNextEditor />}
            exact
          />
          <Route
            path={pageURLs.strengthenAdResponsive}
            element={<StrengthenWantAd />}
            exact
          />
          <Route
            path={pageURLs.mobileWantAdFavorites}
            element={<WantAdFavorites />}
            exact
          />
          <Route
            path={pageURLs.clientFavoriteSummary}
            element={<ClientFavorites />}
            exact
          />
          <Route
            path={pageURLs.mobileEditWantAd}
            element={<CreateWantAdNextEditor />}
            exact
          />
          <Route
            path={pageURLs.strengthenInventoryReponsive}
            element={<StrengthenInventoryResponsive />}
            exact
          />
          <Route
            path={pageURLs.mobileCreateInventory}
            element={<AddPropertyInInventory />}
            exact
          />
          <Route
            path={pageURLs.mobileEditInventory}
            element={<AddPropertyInInventory />}
            exact
          />
          <Route
            path={pageURLs.viewFullGallery}
            element={<ImagesFullGallery />}
            exact
          />
          <Route
            path={pageURLs.wantAdTutorialResponsive}
            element={<TutorialProfileSetup />}
            exact
          />
          <Route
            path={pageURLs.inventoryTutorialResponsive}
            element={<InventoryTutorialSetup />}
            exact
          />
          <Route
            path={pageURLs.mobileSignIn}
            element={<UserRegister />}
            exact
          />
          <Route path="/mobile/update-plan" element={<UserRegister />} exact />
          <Route
            path={pageURLs.viewAd}
            element={
              <ErrorBoundary>
                <HandleViewWantAd />
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path={`${pageURLs.viewAd}/:wantAdId`}
            element={
              <ErrorBoundary>
                <HandleViewWantAd />
              </ErrorBoundary>
            }
            exact
          />

          <Route
            path={pageURLs.changePassword}
            element={<ResetPassword />}
            exact
          />
          {/* inapp notifications */}
          <Route path={pageURLs.mobileInapp} element={<Inapp />} exact />
          {/* receive intro  notifications */}
          <Route
            path={pageURLs.mobileReceiveIntroNotification}
            element={<ReceiveIntroductionNotification />}
            exact
          />
          <Route
            path={pageURLs.proDashboard}
            element={<ProDashboard />}
            exact
          />
          <Route
            path={pageURLs.agentClientListing}
            element={<AgentClientsListing />}
            exact
          />
          <Route path="/mobile/view-client" element={<ViewClient />} exact />
          <Route
            path={pageURLs.mobileClientWantAd}
            element={<ViewClientWantAd />}
            exact
          />
          <Route
            path="/mobile/view-client-inventory"
            element={<ViewInventoryClient />}
            exact
          />
          <Route path={pageURLs.myWantAds} element={<WantAdListing />} exact />
          <Route
            path="/mobile/client-notes-list"
            element={<ClientNotesListing />}
            exact
          />
          <Route path={pageURLs.mobileHome} element={<MobileHome />} exact />
          <Route path={pageURLs.mobileMatch} element={<MobileHome />} exact />
          <Route
            path={pageURLs.mobileSettings}
            element={<SettingsMob />}
            exact
          />
          <Route
            path="/mobile/member-view-property"
            element={<MemberViewProperty />}
            exact
          />
          {/* manage Inventory */}
          <Route
            path={pageURLs.mobileManageInventory}
            element={<ManageInventory />}
            exact
          />
          <Route
            path={pageURLs.mobileAccountSettings}
            element={<AccountSettings />}
            exact
          />
          <Route
            path={pageURLs.mobilePremiumAgentProfileEdit}
            element={<ProfileAgentUserPremiumEdit />}
            exact
          />
          <Route
            path={pageURLs.mobileEditSettingsEmail}
            element={<SettingsEditEmail />}
            exact
          />
          <Route
            path={pageURLs.mobileEditEmailCheck}
            element={<SettingsCheckEmail />}
            exact
          />
          <Route
            path={pageURLs.mobilesettingsEditName}
            element={<SettingsEditName />}
            exact
          />
          <Route
            path={pageURLs.mobileAddPaymentMethod}
            element={<AddPaymentMethod />}
            exact
          />
          <Route
            path={pageURLs.mobilePaymentHistory}
            element={<PaymentHistory />}
            exact
          />
          <Route
            path={pageURLs.mobileEmailNotification}
            element={<EmailNotification />}
            exact
          />
          <Route
            path={pageURLs.mobileMessages}
            element={<HandleMessagesScreens />}
            exact
          />

          <Route
            path={pageURLs.mobileDirectMessages}
            element={<HandleDirectMessagesScreens />}
            exact
          />
          <Route
            path={pageURLs.mobileInventoryIntroduction}
            element={<InventoryAllIntroductions />}
            exact
          />
          <Route
            path={pageURLs.mobilePremiumAgentCreateWantAd}
            element={<CreateAdFormEditor />}
            exact
          />
          <Route
            path="/user-type"
            element={
              // <RequireAuth roles={}>
              <UserTypeSelection />
              // </RequireAuth>
            }
            exact
          />

          <Route
            path="/agent-info/:slug"
            element={
              <ErrorBoundary>
                <AgentInfo />
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path="/reports/active-buyer/:inventoryId"
            element={
              <RequireAuth roles={[2]}>
                <ActiveBuyerReport />
              </RequireAuth>
            }
            exact
          />
        </Routes>
        </PersistentDashboardShell>
        </EnterpriseTourProvider>
      )}
      </BLSGateWrapper>
    </LoadingProvider>
  );
}

export default App;
